module.exports = __webpack_public_path__ + "static/media/mobile-nav-notifications.0763c364.svg";